var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-checkbox h-4 w-4 text-gray-600",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked}})
}
var staticRenderFns = []

export { render, staticRenderFns }